import React from 'react';

const pendingIcon = 
    <img src="/images/admin/global/status/warning.svg" width="16px" alt="" />
export default pendingIcon;